import { html } from 'lit'
import './color/color.js'
import './dropdown/dropdown.js'
import './swatch/swatch.js'
import './image/image.js'
import type { DisplayType } from 'components/discovery/variant-filter/typing/shared-types.js'

const colors: DisplayType = (context) => html`
  <csc-variant-filter-color
    .attribute="${context.attribute}"
    .callback="${context.selectOption}"
    .displayLimit="${context.displayLimit}"
    .filterContainsDropdown="${context.filterContainsDropdown}"
  ></csc-variant-filter-color>
`

const images: DisplayType = (context) => html`
  <csc-variant-filter-image
    .attribute="${context.attribute}"
    .callback="${context.selectOption}"
    .displayLimit="${context.displayLimit}"
    .filterContainsDropdown="${context.filterContainsDropdown}"
  ></csc-variant-filter-image>
`

const swatches: DisplayType = (context) => html`
  <csc-variant-filter-swatches
    .attribute="${context.attribute}"
    .callback="${context.selectOption}"
    .displayLimit="${context.displayLimit}"
    .filterContainsDropdown="${context.filterContainsDropdown}"
  ></csc-variant-filter-swatches>
`

const dropdown: DisplayType = (context) => html`
  <csc-variant-filter-dropdown
    .attribute="${context.attribute}"
    .callback="${context.selectOption}"
    .chooseFilterText="${context.chooseFilterText}"
  ></csc-variant-filter-dropdown>
`

export const displayTypeMap: Record<string, DisplayType> = {
  'property_color': colors,
  'property_image': images,
  'product_image': images,
  'dropdown': dropdown,
  'property_text': swatches,
}

export const getDisplayType = (displayMode: string | undefined): DisplayType | undefined => {
  return displayTypeMap[displayMode ?? 'dropdown']
}
